import { useState, useEffect } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifTextArea,
  MotifFormField,
} from "@ey-xd/motif-react";
import "./RejectSkuModal.scss";
import { SKU_REJECT, SKU_REJECT_COST_TYPE } from "../../pages/BMOSkuApproval/Constants";
import { isStringHavingSpecialChars } from "../../utils/Validator";

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
  rejectHandler?: (
    action?: string,
    msg?: string,
    skuId?: string
  ) => void;
  selectedSku?: string;
  selectedSkuName?: string;
  requestType?: string;
  isLoading?: boolean;
  apiErrorMessage?: string;
  onClearApiError?: () => void;
};

export default function RejectSkuModal({
  show,
  setShow,
  rejectHandler,
  selectedSku,
  selectedSkuName,
  requestType,
  isLoading,
  apiErrorMessage,
  onClearApiError,
}: Props) {
  const [rejectValue, setRejectValue] = useState("");
  const isCostType = requestType === "New SKU" ? false : true;
  const aditionalDesc = isCostType ? "a cost update request for" : "";
  const rejectLabel = "Reject SKU";

  useEffect(() => {
    if (show) {
      setRejectValue("");
      onClearApiError?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (isStringHavingSpecialChars(e.target.value)) {
      return;
    }
    onClearApiError?.();
    setRejectValue(e.target.value);
  };

  const handleRejectChange = (rejectMssg: string) => {
    if (rejectHandler) {
      rejectHandler(
        isCostType ? SKU_REJECT_COST_TYPE : SKU_REJECT,
        rejectMssg,
        selectedSku
      );
    }
  };

  return (
    <MotifModal
      show={show}
      size="default"
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
      className="rejectConfirmationModalWrapper"
    >
      <MotifModalHeader>
        <span className="header-name">
          {isCostType
            ? "SKU cost update rejection reason"
            : "New SKU rejection reason"}
        </span>
      </MotifModalHeader>
      <MotifModalBody>
        <div>
          <p className="motif-body1-default-light rejection-reason">
            You are about to reject {aditionalDesc}{" "}
            <b>
              {selectedSkuName} – {selectedSku}
            </b>
            .<br />
            Explain the rejection reason for the stakeholders.
          </p>
          <MotifFormField role="group">
            <MotifTextArea
              aria-label="RejectionMessage"
              ariaLabel="RejectionMessage"
              maxLength={250}
              onChange={handleChange}
              placeholder="Type..."
              value={rejectValue}
              hideClearButton={true}
            />
            {apiErrorMessage && (
              <div className="reason-error-message">{apiErrorMessage}</div>
            )}
          </MotifFormField>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          type="button"
          variant="secondary"
          onClick={() => {
            onClearApiError?.();
            setShow(false);
          }}
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          type="button"
          className="rejectBtn"
          disabled={rejectValue.trim() === ""}
          loading={isLoading}
          onClick={() => {
            handleRejectChange(rejectValue);
            // setShow(false);
          }}
        >
          {rejectLabel}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}
